import React, { createContext } from 'react';
import PropTypes from 'prop-types';

const AppFabricContext = createContext({});
AppFabricContext.displayName = 'AppFabricContext';

const ContextProvider = ({ children, instance, profiler, setProfiler }) => {
  return (
    <AppFabricContext.Provider value={{ instance, profiler, setProfiler }}>
      {children}
    </AppFabricContext.Provider>
  );
};

ContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
  instance: PropTypes.object,
  profiler: PropTypes.object,
  setProfiler: PropTypes.func,
};

export { ContextProvider, AppFabricContext };
